import o from "./components/button.js";
import r, { PriceTextDeal as m } from "./components/product-price.js";
import t from "./components/add-to-cart-button.js";
import e from "./components/banner.js";
import i from "./components/breadcrumbItem.js";
import p from "./components/card.js";
import f from "./components/checkbox.js";
import n from "./components/breakpoints.js";
import a from "./local-tokens/default.js";
import l from "./components/menu-tile.js";
import T from "./components/portal-drawer.js";
import c from "./components/navigation-item.js";
import b from "./components/headline.js";
import d from "./components/popover.js";
const A = {
  components: {
    BreadcrumbItem: i,
    Button: o,
    PriceText: r,
    PriceTextDeal: m,
    AddToCartButton: t,
    Card: p,
    Banner: e,
    Checkbox: f,
    MenuTile: l,
    NavigationItem: c,
    Headline: b,
    Popover: d
  },
  styles: {
    global: {
      ...T,
      body: {
        fontFamily: null
      }
    }
  },
  breakpoints: n,
  localTokens: a
};
export {
  A as Theme
};
